export default __webpack_public_path__ + "static/perfect-ccba2115e0c9171a83f1586678a2e0b5.png";